
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Pourquoi une identité visuelle forte est essentielle pour une marque ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Une identité visuelle forte différencie votre marque, renforce la crédibilité et marque les esprits. Découvrez pourquoi et comment avec ALEO.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Pourquoi une identité visuelle forte est essentielle pour une marque ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Une identité visuelle forte différencie votre marque, renforce la crédibilité et marque les esprits. Découvrez pourquoi et comment avec ALEO.",
        },
      ],
    };
  },
};
